import { render, staticRenderFns } from "./FactTaxPlan.vue?vue&type=template&id=67184da6&"
import script from "./FactTaxPlan.vue?vue&type=script&lang=js&"
export * from "./FactTaxPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports